var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-group-header",class:{ 'dark-mode': _vm.darkMode, }},[_c('ButtonGroup',[_c('ButtonClassic',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.$tc(
          'panier.x-selection-dans-panier',
          _vm.quantiteLigne,
          { selection: _vm.quantiteLigne, }
        ),
        placement: 'bottom',
        delay: { show: 800, },
      }),expression:"{\n        content: $tc(\n          'panier.x-selection-dans-panier',\n          quantiteLigne,\n          { selection: quantiteLigne, }\n        ),\n        placement: 'bottom',\n        delay: { show: 800, },\n      }"}],attrs:{"id":"bouton_panier","variant":"solid","color":"secondary","size":"medium"},on:{"click":function($event){return _vm.$router.push({ name: 'panier', })}}},[_c('IconPanier',{attrs:{"height":"16","width":"16"}}),(_vm.quantiteLigne > 0)?_c('Counter',{attrs:{"value":_vm.spaceNumber(_vm.quantiteLigne),"size":"small"}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }